import apiClient from '../axios.js'

/**
 * 客戶帳號管理 API
 */
export const clientAccountService = {
    /**
     * 獲取客戶帳號列表
     * @param {Object} params - 查詢參數
     * @param {number} params.page - 頁碼
     * @param {number} params.pageSize - 每頁數量
     * @param {string} params.search - 搜尋關鍵字
     * @param {string} params.clientId - 客戶 ID（可選）
     * @returns {Promise<Object>} 帳號列表
     */
    getAccounts: async (params = {}) => {
        const response = await apiClient.get('/system/clients/accounts', { params })
        return response
    },

    /**
     * 獲取單一客戶帳號詳情
     * @param {string} id - 帳號 ID
     * @returns {Promise<Object>} 帳號詳情
     */
    getAccount: async (id) => {
        const response = await apiClient.get(`/system/clients/accounts/${id}`)
        return response
    },

    /**
     * 新增客戶帳號
     * @param {Object} accountData - 帳號資料
     * @param {string} accountData.username - 使用者名稱
     * @param {string} accountData.password - 密碼
     * @param {string} accountData.email - Email
     * @param {string} accountData.name - 姓名
     * @param {string} accountData.clientId - 客戶 ID
     * @param {string} accountData.role - 角色（可選，預設 client_owner）
     * @param {string} accountData.status - 狀態（可選，預設 active）
     * @param {boolean} accountData.hasAllPermissions - 是否有全部權限（可選，預設 false）
     * @param {Array<string>} accountData.permissions - 權限列表（可選，預設 []）
     * @returns {Promise<Object>} 新增結果
     */
    createAccount: async (accountData) => {
        const response = await apiClient.post('/system/clients/accounts', accountData)
        return response
    },

    /**
     * 更新客戶帳號
     * @param {string} id - 帳號 ID
     * @param {Object} accountData - 帳號資料
     * @returns {Promise<Object>} 更新結果
     */
    updateAccount: async (id, accountData) => {
        const response = await apiClient.put(`/system/clients/accounts/${id}`, accountData)
        return response
    },

    /**
     * 刪除客戶帳號
     * @param {string} id - 帳號 ID
     * @returns {Promise<Object>} 刪除結果
     */
    deleteAccount: async (id) => {
        const response = await apiClient.delete(`/system/clients/accounts/${id}`)
        return response
    },
}
